import {homeEn} from './home/homeEn.js';
import {memberEn} from './member/memberEn.js';
export const message = {
  language: 'English-中文',
  //
  noData: 'Temporarily no data',
  reset: 'reset',
  more: 'more',
  keshi: 'class',
  jinping: 'competitive products',
  zixuncishu: 'Consulting the number：',
  pingfeng: 'score：',
  pingfeng1: 'score',
  day: ' day',
  zjjs: 'Expert introduction',
  qxzzxlx: 'Please select the type of consultation',
  goumaizixun: 'purchase consulting',
  chankanxiangqing: 'view details',
  join: 'Join the list',
  time: 'time',
  lijizixun: 'Immediately consult',
  cankaojia: 'Reference price：',
  num: 'quantity',
  close: 'close',
  baocun: 'save',
  jian: 'piece',
  lijixiadan: 'Place an order immediately',
  //订单
  mianfei: 'Free Admission',
  shoufei: 'charge',
  xianmian: 'Directional Dash ',
  leijipingjia: 'Cumulative evaluation',
  zhixunjiage: 'Consulting price',
  zhixunshichange: 'Consultation duration',
  dingdanxinxi: 'The order information',
  yingfuzongjia: 'Total amount payable',
  youhuijine: 'Discount Amount',
  fuwuzongjine: 'Total service amount',
  fuwu: ' service selected',
  yixuanze: '',
  ddhjhyf: 'Total order (including freight)',
  xuanzefuwu: 'Select a service',
  shangpingxinxi: 'Commodity information',
  fuwuxinxi: 'The service information',
  jibenxinxi: 'The basic information',
  dingdanhao: 'The order number',
  xiadanshijian: 'Place the order of time',
  dingdanzonge: 'The total order',
  dingdanleixing: 'Order type',
  dingdanzhuangtai: 'The order status',
  zhuangjiaxinxi: 'The expert information',
  jiage: 'The price',
  danjia: 'unit price',
  zongji: 'total',
  zhifuxinxi: 'The payment information',
  zhifuContent: 'The order has been submitted, please complete the payment within 48 hours! Late orders will be cancelled.',
  fukuanfangshi: 'Terms of payment',
  fukuanshijian: 'Time of payment',
  youhuiquan: 'coupons',
  fuwuyouhui: 'The service offers',
  yingfujine: 'Amount payable',
  dingdanyouhui: 'The order preferential',
  dingdanliuyan: 'The order to leave a message',
  shuruliuyan: 'The input message',
  fahuoshijian: 'The delivery time',
  guojia: 'countries',
  sheng: 'province',
  shi: 'city',
  qu: 'area',
  xian: 'county',
  xiangxidizhi: 'Detailed address',
  shangchuan: 'upload',
  tianjiafujian: 'Add attachments',
  tijiao: 'submit',
  tijiaodingdan: 'Submit orders',
  readAndAgree: 'I have read and agree',
  sousuo: 'search',
  quanbu: 'all',
  an: 'default',
  xiaoliang: 'sales',
  moRen: 'tacitly approve',
  riqi: 'date',
  wePay: 'WeChat pay',
  aliPay: 'Alipay pay',
  yinlianPay: 'Unionpay online payment',
  paypalPay: 'PayPal payment',
  xianxiaPay: 'Offline payment',
  payContent: 'Upon payment, we agree to the small and medium service platform of ccpit - user agreement.',
  zhanghumingcheng: 'Account name：',
  shoukuanzhanghao: 'Account number：',
  kaifuyinghang: 'Bank name：',
  beizhu: 'note：',
  fhgmjl: 'Return purchase record',
  beizhuplaceholder: 'Please enter remarks',
  shangchuanpingzheng: 'Upload credentials：',
  sfzzmsc: 'Id card front upload',
  sfzfmsc: 'Id card reverse upload',
  baocuncaogao: 'Save drafts',
  xiayibu: 'The next step',
  tishi: 'prompt message',
  queren: 'notarize',
  tianjiashdz: 'Add shipping address',
  tianjiafp: 'Add the invoice',
  bianjifp: 'Edit the invoice',
  zhifu: 'pay',
  zhifufq: 'Payment in installment',
  quxiaodingdan: 'cancellation of order',
  huiyuanquanxian: 'Membership privileges',
  shangchuantupian: 'upload pictures',
  zhonghepingjia: 'comprehensive assessment',
  chucipinglun: 'First comment',
  zuijiapinglun: 'Additional comments',
  pingtaihuifu: 'Platform to reply',
  quxiaozhifu: 'Cancel the payment',
  qzlfznwczf: 'Please pay in two minutes',
  qishu: 'number of periods',
  quanxuan: 'check all',
  cpxx: 'product information',
  jineo: 'money',
  chaozuo: 'operation ',
  shixiao: 'Invalidation',
  shanchu: 'delete',
  jiancheqingdangNull: 'The checklists are empty. Check out your favorite items',
  qucaihou: 'Go shopping',
  baocunjcfa: 'Save detection scheme',
  fanganmingcheng: 'scenario name',
  goumaishuliang: 'purchase quantity：',
  lijigoumai: 'Buy It Now',
  fuwuxiangqing: 'Service details',
  fuwupinglun: 'The service comments',
  anmoren: 'According to the default',
  shijiandaoxu: 'Reverse chronological order',
  shijiansunxu: 'time sequence',
  edit: 'edit',
  qingshurnxgxx: 'Please enter the relevant information',
  baocuncg: 'save successfully',
  baocunshibai: 'fail to save',
  shanchushibai: 'successfully delete',
  shengyu: 'surplus',
  yidaoqi: 'have expired',
  chakan: 'view',
  chongxinsq: 'reapply',
  yishixiao: 'became effective',
  weishixiao: 'ineffective ',
  taochandd: 'Set the order',
  biaozhuidd: 'Standard order',
  return: 'return',
  yishix: 'lost effectiveness',
  lingqu: 'get',
  zhifudingdan: 'pay for the order',
  mashangxiadan: 'place an order',
  shousuo: 'search',
  xiugai: 'modification',
  shezhimr: 'Set as Default',
  qingxuanzhe: 'please select',
  sjhmbnwk: 'The cell phone number cannot be empty',
  qsrzqdsjhm: 'Please enter the correct cell phone number',
  qsrsf: 'Please enter province',
  qsrttmc: 'Please enter the name of the header',
  qsrxxdz: 'Please enter the detailed address',
  qsrnsrxbh: 'Please enter taxpayer identification number',
  qsrsssfsz: 'Please enter the province town',
  qingshurngjz: 'Please enter the keywords',
  weibangding: 'not bound',
  shuaxin: 'refresh',
  qsywxsmewm: 'Please use WeChat to scan the qr code',
  shaoyishaobd: 'Scan binding',
  shifouqrjbwx: 'Are you sure to unbind WeChat?',
  bianji: 'editorial',
  huiyuanmzbnwk: 'Member name cannot be empty!',
  qingtianxnidxb: 'Please fill in your gender!',
  juzdbunwk: 'The residence cannot be empty!',
  xxddbnwk: 'The detailed address cannot be empty!',
  qsrzqdyx: 'Please enter the correct email!',
  tishengczz: 'Enhanced growth value',
  chengzhongzhi: ' growth value',
  manzu: 'meet ',
  goumai: 'buy',
  yigoumai: 'have bought',
  mctpxfwlbjb: 'Trade Promotion Platform service List/level',
  ffhyfwnrhydj: 'Paid membership service content/membership level',
  jinxingzhong: 'have in hand',
  yijieshu: 'have finished',
  shengyuzxsj: 'Remaining consultation time:',
  wodepingjia: 'My evaluation',
  wodezhuiping: 'My review',
  zhuiping: 'additional review',
  fenxaingxinqing: 'Share experience experience, for thousands of people want to buy a reference!',
  pingjiazhishuyaoqiu: 'The evaluation should be no less than 10 words',
  tijiaopingjia: 'Submit evaluation',
  fuwupingjiayiwc: 'Service evaluation has been completed',
  fanhuidaipingjiaList: 'Returns the list to be evaluated',
  pingjiasaidan: 'Evaluation of bask in single',
  fanganbianhao: 'Package number',
  baocunshijian: 'hold time',
  shouqi: 'pack up',
  zhuankai: 'unfold ',
  fananxinximc: 'Solution service information',
  xiugaifanganmc: 'Modify scheme name',
  peixunfuwupingjiayiwc: 'Evaluation of training services has been completed',
  zhifeichengzhuangzhi: 'Integral plus 5, growth plus 10',
  peixunfuwuzhuijiapj: 'Additional evaluation of training orders',
  peixundingdanpj: 'Training Order evaluation',
  jie: ' day course',
  zhuijiapingjia: 'Additional evaluation',
  lijipingjia: 'evaluation',
  lijizifu: 'payment',
  pingtaiyouhuiquan: 'platform coupons',
  youhuiquanduihuanma: 'coupons code',
  hqPayPalsb: 'Failed to get PayPal payment',
  hqzfhsb: 'Failed to get payment number',
  wjscxz: 'Currently limits selection to 1 file',
  wenjianscsb: 'File upload failed',
  qingscpz: 'Please upload your credentials',
  qydbtyyhxy: 'Please read and agree to the User agreement!',
  qwcftjdd: 'Do not repeat the order',
  gddysxqcxxd: 'This order has come into effect, please place a new one',
  tupian: 'picture',
  haoping: 'good reputation',
  zhongping: 'medium review',
  chaping: 'negative comment ',
  zhuijia: 'Additional evaluation',
  gspzwmjpl: 'There is no buyer comment for this product',
  kecengxixi: 'course information',
  xuanzetaocan: 'Choose package',
  zhuanjiamingc: 'Experts name',
  zhuanjiazxts: 'Expert consultation days',
  zwglxdpxfwjqdd: 'There is no training service of this type, please wait!',
  wanzhengsp: 'full video',
  di: '',
  kecheng: 'course',
  kaitongsc: 'The opening time',
  geyue: ' months',
  cpmc: 'product name',
  heji: 'total',
  cpbz: 'product remark',
  sqrxx: 'Applicant information',
  tjddsrrbz: 'Please fill in the form with your real name in Chinese. The information you fill in when you submit the order for the first time will be stored in your account and used for the order application form.After saving will not be able to modify directly, if you have any questions, please contact online customer service.',
  xingming: 'name:',
  qsrxingming: 'Please enter your name',
  qsrlxdh: 'Please enter your contact number',
  dzyx: 'e-mail:',
  qingsrdzyx: 'Please enter your email address',
  qiyexinxibz: 'Please fill in accurately. The enterprise information filled in when you first submit the order will be saved into your account information and used for the order form.If you have any questions, please contact the online customer service',
  qsrgsmc: 'Please enter the company name',
  yangpingcl: 'sample treatment',
  feiqicl: 'waste treatment',
  yuanyangjihui: 'send back',
  yuanyangjhsyf: ' Postage will be charged separately if return as is required',
  mctcpjcrzptxy: 'Ttec Product Testing and Certification Platform Agreement',
  shangchuancg: 'successfully upload',
  shangchuansb: 'fail to upload',
  yicgtcdl: 'Logon logged out successfully',
  huoquylzfsb: 'Failed to get unionPay payment',
  dakaiylzfsb: 'Open unionPay payment failed',
  shouchaungcg: 'Collection of success',
  xianxiazfcg: 'Successful offline payment',
  zhifusb: 'payment failure',
  zhifucg: 'payment success',
  qtxndzxnr: 'Please fill in your inquiry',
  qingtxxm: 'Please fill in your name',
  qingtxsjhm: 'Please fill in your cell phone number',
  qingtxyx: 'Please fill in the email',
  tingtxqymc: 'Please fill in the business name',
  qingtxfwsmc: 'Please fill in the name of the service provider',
  qingxzs: 'Please select a province',
  qingxzshi: 'Please select the city',
  qingxzxq: 'Please select a county/district',
  qingxzfwlx: 'Please select the service type',
  qingxuanzhefw: 'Please select service!',
  qingshurnzxry: 'Please enter the consultation content!',
  qingshurnxm: 'Please enter your name!',
  qingshurnsjhm: 'Please enter your mobile phone number!',
  qingshurnyx: 'Please enter email!',
  qingxuanzhesf: 'Please select the province!',
  qingxuanzecs: 'Please choose a city!',
  qingxuanzedq: 'Please select an area!',
  qingxuanzeqymc: 'Please enter the enterprise name!',
  qingshurnzdfwsbj: 'Please enter the quotation of the specified service provider!',
  qingyuedubtyxy: 'Please read and agree to the agreement!',
  gaifeileiwbdjcx: 'This classification is not bound to a test item',
  qingzsxzyx: 'Please choose at least one',
  qinggouxbtx: 'Please check the required options',
  renzhenfwsccg: 'Authentication service removed successfully',
  qingxaunzegmfw: 'Please select purchase service',
  qingxuanzegnmfamc: 'Please enter the name of the purchase proposal',
  gaifuwuyxj: 'The service is off the shelf!',
  wuxaiosp: 'Invalid goods!',
  gaifuwuysx: 'The service is no longer available!',
  qingxaunzewzdgg: 'Please select the full specification',
  qingshurndwmc: 'Please enter the unit name',
  qingshurnsprxm: 'Please enter the name of the consignee',
  qingshurnsprsf: 'Please select the province of the receiver',
  qingshurnzqdlxdh: 'Please enter the correct contact number',
  qingshurnzqddzyx: 'Please enter the correct email address',
  qingydxybty: 'Please read the agreement and agree!',
  qingwucwtj: 'Please do not repeat submission!',
  qingshurnttmc: 'Please enter the name of the title',
  qingshurnsprsj: "Please enter the receiver's mobile phone",
  qingshurnzqsprsj: "Please enter the correct receiver's mobile phone",
  qingshurnzqspryx: "Please enter the correct receiver's mailbox",
  guojiahuoqusibai: 'State failure',
  fenleihqsb: 'Classification acquisition failure',
  liebiaohqsb: 'List retrieval failed',
  youxiangbnwk: 'The mailbox cannot be empty',
  qingshurnzhensxm: 'Please enter your real name',
  scgs: 'Upload pictures can only be JPG and PNG format!',
  scxzdx: 'Upload image size should not exceed 2MB!',
  qscsfzzmz: 'Please upload the front photo of your ID card',
  qscsfzfmz: 'Please upload the photo on the back of your ID card',
  qscyjzzsmj: 'Please upload the scanned copy of business license',
  qscqyzzzssmj: 'Scan copy of enterprise qualification certificate',
  qscjjclhptzczh: "Please upload the profile materials or the authorization letter of the operator of the platform's registered account",
  qsrzjjj: 'Please enter the expert profile',
  qsczjzzzssmj: 'Please upload the scanned copy of expert qualification certificate',
  qsczjgrlw: 'Please upload personal papers of experts',
  tijiaosb: 'submit failure ',
  qscgajgczdzwbljlsmwj: 'Please upload the scanned file of no bad record issued by the public security organ',
  yishouc: 'have already collected',
  nian: ' year',
  qxzzjfl: 'Please enter expert classification!',
  qxzzjszgj: 'Please select the country where the expert is located!',
  qxzzjsyxxdz: 'Please select the detailed address of the expert!',
  qxzzznx: 'Please select the qualification period!',
  qxzhyfw: 'Please select industry service',
  qxzscqy: 'Please select a good area!',
  qsczzzssnj: 'Please upload the scanned copy of the qualification certificate!',
  qscgrlwfj: 'Please upload your personal paper attachment!',
  qsrjygzjl: 'Please input education work experience!',
  baocuncaogaocg: 'Saved draft successfully',
  qsrnrhscwj: 'Please enter content or upload file',
  gaizjyxj: 'The expert has been removed from the shelves',
  pxlbhqsb: 'Failed to get training list',
  qsrzmbhmc: 'Please enter certificate number/name',
  zscxcg: 'Certificate query successful',
  zscxsb: 'Certificate query failed',
  quxiaoddcg: 'Cancel the order successfully',
  qingsctp: 'Please upload pictures',
  tupianscxz: 'A maximum of 5 pictures can be uploaded',
  qingwucfdj: 'Do not repeat',
  qingsrswzf: 'Please enter 10 characters',
  pingluncg: 'Comment on success',
  pinglunsb: 'Comment on failure',
  zhuipingsb: 'After a review of the failure',
  gaifufuyisixiao: 'The service is no longer available',
  huoquewmsb: 'Failed to obtain qr code, please refresh',
  bangdingcg: 'Binding success',
  gaiwxybdqtzh: 'This WeChat has been bound to other accounts!',
  bangdingsb: 'Binding failure',
  qcxhqewm: 'Please get the QR code again',
  jiebangcg: 'Unbundling success',
  jiebangsb: 'Unbundling failure',
  yangpingjisong: 'The sample sent',
  fenqizifu: 'Payment in installment',
  hengye: 'industry',
  fuwuleimu: 'Service category',
  fuwussss: 'service',
  qingsrfhr: 'Please enter shipper',
  qingsrlxfs: 'Please enter your contact information',
  qingxuanzewllx: 'Please select the logistics type',
  qsrwlbh: 'Please enter the logistics number',
  qsrypmc: 'Please enter sample name',
  qsrypsl: 'Please input sample quantity',
  qsrfhrmc: 'Please enter the name of the shipper',
  qsrfhrsj: "Please enter the shipper's cell phone",
  qxzfhrsf: 'Please select shipper province!',
  qxzfhrcs: 'Please select the consigner city!',
  qxzfhrdq: 'Please select shipper area!',
  qxzfhrxxdz: "Please enter shipper's address!",
  qxzshrmc: 'Please enter the name of consignee',
  qsrshrsj: "Please enter the consignee's mobile phone!",
  qxzshrsf: 'Please select the consignee province!',
  qxzshrcs: 'Please select the consignee city!',
  qxzshrdq: "Please enter the consignee's area!",
  qxzshrxxdz: "Please enter the consignee's detailed address!",
  qxzypclfs: 'Please select sample treatment',
  gfwzwjcfw: 'There is no test service for this service',
  zszwscqnxdd: 'The certificate has not been generated yet, please wait patiently',
  wuliugenzhongztxx: 'Logistics tracking status information',
  querenshouhuo: 'confirm receipt',
  chakanwuliu: 'check logistics',
  xuyaojihui: 'Need to send back to you',
  buxuyaojihui: "It doesn't have to be mailed back",
  qtxplnr: 'Please fill in the evaluation',
  zhuipingcg: 'After a review of the success',
  tupianscsb: 'Photo upload failed',
  qxzxyscdsj: 'Please select the data to be deleted',
  gaidingdanyisc: 'An application form has been generated for this order. Please pay in the member center - Order list!',
  qingshurn: 'please input',
  qingshurnrzjggs: 'Please enter certification body/company',
  qingshurntyjgdmz: 'Please enter the Uniform Organization Code Certificate',
  qingshurnjcjghm: 'Please enter your mobile phone number',
  qingxzgj: 'Please select country',
  qingxzjcrzfwxm: 'Please select the test and certification service item',
  qingxzjcrxzgj: 'Please select the testing and certification service country',
  qingtxgsjj: 'Please fill in the company profile',
  qingxzssq: 'Please select a province or city',
  qingtxqyszd: 'Please fill in the location of the business',
  qingscsmjyizl: 'Please upload the scanned copy and data',
  qingtxbtx: 'Please fill in the required fields',
  jingkcygm: 'Only courses have been purchased',
  jingkc: 'Only courses',
  qingxzkthytc: 'Please choose to open the membership package',
  xuanzezhmmfs: 'Password recovery method:',
  bangdingyx: 'bind email address',
  qingshurnybdyx: 'Please enter the bound mailbox',
  tgbdyxzhzhmm: 'Retrieve password by binding email account',
  tgbdsjhmzhmm: 'Retrieve password by binding mobile phone number',
  qxzzhmmdfs: 'Please select the way to retrieve your password',
  qsrbdyx: 'Please enter the binding mailbox',
  sryzmywhzhyw: 'Failed to send verification code. Or the account number is incorrect.',
  yanzhengmacuowu: 'Verification code error!',
  yzyxysd: 'Verify that the message has been delivered',
  qdlyxdj: 'Please log in the email and click the activation link to retrieve the password. The activation link will be valid within 30 minutes',
  qcsyj: 'Please check your email.',
  qzxqwyxcsyj: 'Please go to your mailbox to check your email',
  yjyfsbycfdj: "The email has been sent. Don't repeat it",
  fasongyjsb: 'Failed to send email',
  xiugaidlmm: 'Change login password:',
  denglummqr: 'Login password confirmation:',
  zcsrmm: 'Please enter your password again',
  shezhimima: 'set a password',
  mimagsbudui: 'The password should be at least 8 digits (!@#$%^&*_. These are the only characters)',
  liangcimmbyz: 'The two passwords do not match',
  xiugaisibai: 'change failed',
  nycgxgmctdlmm: 'You have successfully changed the login password of TCT product testing and certification platform!',
  msdlbfhsy: 'Log in and return to the home page',
  tongguoyanz: 'by verifying',
  nyjtgyxyz: 'You have successfully passed the email verification!',
  youxiangyzsb: 'Email verification failed!',
  yanzhengzhxx: 'Verify account information',
  mmxgcg: 'Password changed successfully',
  xiugaidlmm1: 'Change login password',
  huiyuandenglu: 'member login',
  zhuanghu: 'account',
  qsrzhm: 'Please enter your account',
  mima: 'password',
  qingsrmima: ' Please enter your password',
  dlmhmmcw: 'Incorrect account name or password',
  denglu: 'register',
  baocundlxx: 'Save login information',
  wangjimima: 'forget the password',
  wancptyz: 'Complete jigsaw verification',
  huanyizheng: 'In a',
  shaoyisaodl: 'Scan login',
  zhmmdl: 'Account password login',
  shaomadlcg: 'The code scanning is successful, the first login, please use the password to login binding WeChat',
  qingsrzh: 'Please enter your account number',
  yanzhengsb: 'verification failed!',
  shaoyisaozc: 'Scan quick register',
  shoujizc: 'Mobile phone registered',
  youxiangzc: 'Registered mail',
  nicheng: 'nickname',
  qsrndnc: 'Please enter your nickname',
  zaicishurnmima: 'Enter the password again',
  zucezg: 'Congratulations to you!You have successfully registered as a member of TTEC product testing and certification platform!If you encounter any problem in use, please contact the customer service of the platform in time!',
  dengluzh: 'login account ',
  lijidenglu: 'Login immediately',
  wxsmzcdl: 'WeChat scan to register your account',
  txxxbszmm: 'Fill in the information and set the password',
  zhucecg: 'registered successfully',
  qingshurnndyxzh: 'Please enter your email account',
  xieyi: '《Ttec Product Testing and certification Platform Registration Agreement》',
  weixizuce: 'WeChat registered',
  lainjiyouxiaoqi: 'Please log in the email and click the activation link to complete the email registration. The activation link will be valid within 24 hours',
  meiyoushpooudao: 'No mail?',
  mmylwszzc: 'The password consists of six digits',
  qingsryzm: 'Please enter verification code!',
  qingsrzqdyzm: 'Please enter the correct verification code!',
  yzmyfsqdlyxck: 'Verification code has been sent, please log in the email!',
  gaiyouxiangyzc: 'This email has been registered!',
  mimazuc: 'The password consists of 6-16 digits!',
  qingshurunc: 'Please enter a nickname',
  yifasongyzm: 'Verification code has been sent',
  gaizhyzc: 'The account has been registered!',
  fenqifukuan: 'installment:',
  juliczzkong: '',
  juliczzzhi: ' growth from the next level',
  changzhengzhimingxi: 'Growth value details',
  xingwei: 'behavior',
  changzhengzhibianhua: 'Change of growth value',
  pingjia: 'evaluate',
  xiaofei: 'consumption',
  qxzhydj: 'Please select the membership level',
  goumaihuiyuan: 'Purchase a membership',
  baogaoxinshi: 'report form：',
  huiyuandengji: 'level of membership：',
  huiyuanjiage: 'The member price：',
  tishengfuwuxiangmu: 'Upgrade service items',
  kaitongviphuiyuan: 'Open VIP membership',
  gxntjddcg: 'Congratulations! The order was submitted successfully!',
  ljqwddlbtxsqb: 'Go to the order list immediately and fill out the application form',
  caozuochenggong: 'Successful operation',
  ryywqlxptcxbj: 'If you have any questions, please contact the platform for',
  zjzxpj: 'Expert consultation evaluation',
  zjzxpjywc: 'Expert evaluation has been completed',
  zfjzjj: 'Consulting hours:',
  xiaoshi: ' hour',
  zhuanjiashuiping: 'Expert level:',
  huifuziliang: 'Reply quality:',
  huifusudu: 'reply speed:',

  //首页
  ...homeEn,
  // member里的路由
  ...memberEn,
  // 顶部
  topNav: {
    login: 'Hello, please sign in',
    register: 'Register',
    join: 'Join us',
    member: {
      text: 'Member Center',
      perMember: 'Enterprise Center',
      woOrder: 'my order',
      busMember: 'Service Center',
    },
    understand: 'Trade Access Master',
    guide: ' Guideline',
    gadget: {
      text: 'Gadget',
    },
    Hello: 'Hello',
    signOut: 'Sign out',
  },
  // 导航栏
  menu: {
    zaxianzhixun: 'Online customer service',
    kefurexian: 'Customer service hotline',
    guanzhugongzonghao: 'Follow the public account',
    fanhuidingbu: 'Return to the top',
    jiancheqingdang: 'Test list',
    lijikszx: 'Start consulting now',
    yzyrygtkhfw: 'Communicate customer service solutions with professionals',
    qgkfrexian: 'National customer service hotline',
    meirizhixun: 'Daily information',
    zaixianxiadang: 'Order online',
    home: 'Home',
    policy: 'Policy advocacy',
    meiyouzh: 'There is no account',
    mashangzc: 'Immediately registered',
    yiyouzh: 'Existing account',
    mashangdl: 'Login immediately',
    verify: {
      text: 'Commercial certification',
      child: {
        a: 'Certificate of Origin',
        b: 'Commercial Certificate',
        c: 'ATA Carnets',
        d: 'Consular certification',
        e: 'certificate of free sale',
        f: "Certificate of China's Export Brand",
      },
    },
    legal: {
      text: 'Legal Service ',
      child: {
        a: 'Commercial Conciliation',
        b: 'Arbitration Service',
        c: 'Comprehensive Legal Service',
      },
    },
    foreign: {
      text: 'Foreign Trade Service ',
      child: {
        a: '1039 Service',
        b: 'Customs Clearance Service',
        c: 'Storage Service',
        d: 'Logistics Service',
      },
    },
    knowledge: {
      text: 'Property rights ',
      child: {
        a: 'Trademark',
        b: 'Patent',
      },
    },
    testing: {
      text: 'Testing certification ',
      child: {
        a: 'Home',
        b: 'Data bank',
        c: 'Training services',
        d: 'Expert center',
        e: 'Agent channel',
      },
    },
    comprehensive: {
      text: 'Comprehensive Service',
      child: {
        a: 'Business Agency',
      },
    },
    about: {
      text: 'About us ',
      child: {
        a: 'Introduction of Trade Promotion Center',
        b: 'Speech',
        c: 'Contact information',
        d: 'Recruitment Information',
        e: 'On Trade Promotion',
      },
    },
  },
  // 个人中心-左侧导航栏
  memberNav: {
    testing: {
      text: 'Testing and certification',
      home: 'Home',
      order: 'Order',
      inquiry: 'Inquiry sheet',
      plan: 'Test plan',
      evaluate: 'Order evaluation',
    },
    train: {
      text: 'Train',
      course: 'Courses purchased',
      order: 'Training order',
      evaluate: 'Courses evaluate',
    },
    consult: {
      text: 'Expert consultation',
      myConsult: 'My advice',
      order: 'order',
      evaluate: 'evaluate',
    },
    account: {
      text: 'Account service',
      info: 'Membership information',
      collect: 'Member collection',
      integral: 'Integral management',
      coupon: 'My coupon',
      certificate: 'Certificate management',
      specimen: 'Sample management',
      record: 'Browse record',
      docking: 'Customer docking',
      address: 'Address book',
      invoice: 'Invoice information',
      afterSaleList: 'After sales service list',
      afterSaleSev: 'After sale management',
      grade: 'Membership level',
      userpass: 'User password change',
    },
  },
  // 底部
  footer: {
    top: {
      CCPIT: 'CCPIT',
      service: 'CCPIT Commercial Service',
      office: 'CCPIT Patent And Trademark Law Office',
      lvhui: 'Law - international business legal service platform',
    },
    about: {
      text: 'About us',
      understand: 'Trade Access Master',
    },
    commercial: {
      text: 'Commercial certification',
      origin: 'Certificate of Origin',
      certificate: 'Commercial Certificate',
      carnets: 'ATA Carnets',
      consular: 'Consular certification',
      freeSale: 'certificate of free sale',
      exportBrand: "Certificate of China's Export Brand",
    },
    testing: {
      text: 'Testing and certification',
      electromechanical: 'Electromechanical',
      textile: 'Textile and garment',
      medical: 'Food and medical',
      other: 'Other',
    },
    Legal: {
      text: 'Legal Service',
      conciliation: 'Commercial Conciliation',
      arbitration: 'Arbitration Service',
      comprehensive: 'Comprehensive Legal Service',
    },
    foreign: {
      text: 'Foreign Trade Service',
      service: '1039 Service',
      clearance: 'Customs Clearance Service',
      storage: 'Storage Service',
      logistics: 'Logistics Service',
    },
    property: {
      text: 'Property rights',
      trademark: 'Trademark',
      patent: 'Patent',
    },
    comprehensive: {
      text: 'Comprehensive Service',
      agency: 'Business Agency',
    },
    foot: {
      development: 'Trade Development & Cooperation Center of CCPIT',
      council: 'China Council for the Promotion of International Trade(Guangdong)Pilot Free Trade Zone Nansha Service Center',
      copyright: 'Copyright© China Trade Technology (Guangzhou) Co.,Ltd',
      NanSha: 'NanSha Office Location:1101-1106, Innovation Tower, Jinmao Bay, Nansha District, Guangzhou',
      location: 'TianHe Office Location:30 Floor, West Tower, TianYing Square, Tianhe District, Guangzhou',
      national: 'National Customer Service Hotline:400-008-0170',
    },
  },
  //ZSteps组件
  zsteps: {
    tianxiezhm: 'Fill in account name',
    yanzhengshenfen: 'authentication',
    shezhixinmima: 'Set a new password',
    wancheng: 'accomplish',
    tianxiezxxx: 'Fill in the consulting information',
    tijiaocg: 'submit successfully',
    tijiaodd: 'submit order',
    tianxiesqb: 'fill in the application form ',
    zhifu: 'pay',
    fwwuzhong: 'in service',
    xiazaibaogao: 'Download the report/evaluation',
    tianxieruzzl: 'Fill in the entry information',
    pingtaishenhe: 'Platform audit',
    ruzhucg: 'In a successful',
    dingdanjiaoyiwc: 'Order completion',
  },
  MyCoupons: {
    wdyhq: 'My coupons',
    youxiaoqkssj: 'Period of validity',
    kssj: 'start time',
    jssj: 'end time',
    youxiaoqjssj: 'End of validity period',
    youhuiquanleixing: 'Coupon type',
    youhuiquanmc: 'Coupon name',
    qingshuruyouhuiquanmc: 'Please enter the name of the coupon',
    quanbuyouhuiquan: 'All coupons',
    weishiyong: 'unused',
    yishiyong: 'have been used',
    yiguoqi: 'have expired',
    lingquyouhuiquan: 'receive a coupon',
    ahznwuxgyhq: 'No coupons available',
    qianwanglq: 'To get the',
    man: 'The full',
    keyong: 'available',
    xianpinglei: 'Limit of category',
    xianpingtai: 'Restricted platform',
    quanbianhao: 'Ticket number',
    weiqiyongf: 'not enabled',
    lijishiyong: 'immediate use',
    tongyongyouhuiquan: 'Universal coupon',
    fuyouhuiquan: 'Service coupon',
    pxfwyouhuiquan: 'Training video coupon',
    zxzjyouhuiquan: 'Consulting expert coupons',
    quanbufw: 'All service',
    zhidingfenlei: 'Specify the classification',
    zhidingsp: 'Specify the commodity',
  },
  status: {
    daizhifu: 'To be paid',
    daicaishen: 'To be audited',
    yizhifu: 'Paid',
    yiwancheng: 'Completed',
    yipingjia: 'Already evaluated',
    yizuiping: 'Reviewed',
    yiquxiao: 'Cancelled',
    zhifubao: 'Alipay',
    weixinzf: 'WeChat Pay',
    yinglian: 'Unionpay',
    xianxiazf: 'offline payment',
    paypalzf: 'Paypal payment',
    xcxzf: 'applet payment',
    xcxxxzf: 'Applet offline payment',
    zhuce: 'register',
    fuwudingdan: 'service order form',
    fwddpj: 'Service Order evaluation',
    zhuanjiadingdan: 'Experts orders',
    zjddpj: 'Expert order evaluation',
    peixunfuwudingdan: 'Training Service Order',
    pxfwddpj: 'Training service order evaluation',
    kthydd: 'Open membership order',
    dmyhq: 'Coupon redemption',
    shenghe: 'In audit',
    fwwuzhong: 'in service',
    baojiazhong: 'in the quotation',
    yibaojia: 'Quoted price',
    yixiadan: 'placed an order',
    daifukuan: 'wait for payment',
    jiaoyiguanbi: 'Trading closed',
    zhixunzhong: 'Is consulting',
    shenqingdingdan: 'To apply for the order',
    daishenghe: 'To audit',
    daitianxsqb: 'Application Form to be filled',
    caishencg: 'Its successful trial',
    caishrenbh: 'Rejected goods on',
  },
};



// WEBPACK FOOTER //
// ./src/lang/en.js